$(function(){
    const fbSettings = {
        closeExisting: true,
        type: 'html',
        baseClass: 'b-flip-card__modal-layout',
        slideClass: 'b-flip-card__modal-slide',
        animationEffect: 'slide',
        transitionEffect: 'slide',
        animationDuration: 800,
        touch: false,
        arrows: false,
        loop: true,
        btnTpl: {
            smallBtn: `
                <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
                    <svg viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line y1="-0.5" x2="37.8844" y2="-0.5" transform="matrix(-0.705147 -0.709061 0.705147 -0.709061 27.7142 27.8573)" stroke="black"/>
                        <line y1="-0.5" x2="37.8855" y2="-0.5" transform="matrix(0.704396 -0.709807 0.704396 0.709807 1.00073 28.8507)" stroke="black"/>
                    </svg>
                </button>`
        },
    };

    $('.b-flip-cards').each(function(){
        var $context = $(this),
            $slider = $('.b-flip-cards__list', $context),
            $item = $('.b-flip-cards__item', $context),
            settings = {
                slidesToShow: 5,
                arrows: true,
                dots: false,
                swipeToSlide: true,
                touchThreshold: 10,
                infinite: false,
                prevArrow:'<div class="b-slider-arrows__prev"><svg width="20" height="34" viewBox="0 0 20 34" xmlns="http://www.w3.org/2000/svg"><path d="M16.5859 33.4142L0.171665 17L16.5859 0.585788L19.4143 3.41422L5.82852 17L19.4143 30.5858L16.5859 33.4142Z"></path></svg></div>',
                nextArrow:'<div class="b-slider-arrows__next"><svg width="20" height="34" viewBox="0 0 20 34" xmlns="http://www.w3.org/2000/svg"><path d="M16.5859 33.4142L0.171665 17L16.5859 0.585788L19.4143 3.41422L5.82852 17L19.4143 30.5858L16.5859 33.4142Z"></path></svg></div>',
                responsive: [
                    {
                        breakpoint: 1700,
                        settings: {
                            slidesToShow: 4
                        }

                    },
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 3
                        }

                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2
                        }

                    },
                    {
                        breakpoint: 560,
                        settings: {
                            slidesToShow: 1
                        }

                    }
                ]
            };
        $slider.slick(settings);

        const fbItems = [];

        $item.each(function(){
            var $thisItem = $(this);
            var $hoverContent = $('.b-flip-card__hover-content', $thisItem);

            fbItems.push({
                src: $hoverContent,
                type: 'html',
            });

            if($hoverContent) {
                $thisItem.on('click', function(){
                    if($context.attr('data-content-show') === '[1]' && $('.landing-edit-mode').length < 1) {
                        $.fancybox.open(fbItems, fbSettings, $thisItem.index());
                    }
                });
            }
        });
    });

    $('body').on('click', '.b-flip-card__left-arrow, .b-flip-card__right-arrow', (e) => {
        const $arrow = $(e.currentTarget);
        const direction = $arrow.hasClass('b-flip-card__left-arrow') ? -1 : 1;

        if (direction > 0) {
            $.fancybox.getInstance().next( 800 )
        } else {
            $.fancybox.getInstance().previous( 800 )
        }
    });
});
